import { companyFragment } from '../fragments/CompanyFragment'
import type {
  UpdateCompanyMutation,
  UpdateCompanyMutationVariables
} from './__generated__/UpdateCompanyMutation'
import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'

const mutation: TypedDocumentNode<
  UpdateCompanyMutation,
  UpdateCompanyMutationVariables
> = gql`
  ${companyFragment}

  mutation UpdateCompanyMutation($input: UpdateCompanyInput!, $locale: String) {
    updateCompany(input: $input) {
      company {
        ...CompanyFragment
      }
    }
  }
`

export function updateCompanyMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      UpdateCompanyMutation,
      UpdateCompanyMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
